import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {
    const controller = new JsController(app, 'Takeover Card');
    controller.addMountFunction(() => {
        mountTakeoverCard(controller);
    })
    return controller.init();
}


export function mountTakeoverCard( controller: JsController ) {
    const elements = document.querySelectorAll<HTMLElement>(`.takeover-card-component`);
    let index = 0;
    for (const element of elements) {
        handleScrollArrowClick(controller, element);
        index++;
    }
}

const handleScrollArrowClick = (controller: JsController, element: HTMLElement) => {
    const slideArrows = element.querySelectorAll('.scroll-to-bottom-of-hero');
    if (slideArrows.length > 0) {
        for (const slideArrow of slideArrows) {
            controller.addListener(slideArrow, "click", () => {
                const navigation = document.querySelector<HTMLElement>('.navigation');
                const navigationHeight = navigation ? navigation.clientHeight : 0;
                const scrollToPos = element.getBoundingClientRect().bottom + window.scrollY - navigationHeight;
                window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
            });
        }
    }
}